import {useHistory} from "react-router-dom";
import { Link } from "react-router-dom"


const HubsTable = (props) => {
  const history = useHistory();

  return (
    <div className="flex flex-col">

      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    店舗名
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    住所
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    クーポン
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    編集
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {props.hubs.map((hub) => (
                  <tr key={hub.id}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <Link to={"/sponsor/hubs/" + hub.id + "/coupons"}>
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            {
                              hub.image ?
                              <img className="h-10 w-10 rounded-full object-cover" src={hub.image} alt="hub" />
                              :<img className="h-10 w-10 rounded-full object-cover" src="/static/img/default_profile_image.png" alt="hub" />
                            }
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">{hub.name}</div>
                          </div>
                        </div>
                      </Link>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">〒{hub.postal_code}</div>
                      <div className="text-sm text-gray-900">{hub.state}{hub.city}{hub.address_line_1}{hub.address_line_2}</div>
                    </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-500">
                        <button className="border-b border-blue-500" onClick={() => history.push("/sponsor/hubs/" + hub.id + "/coupons")}>このお店のクーポン</button>
                      </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-blue-500">
                        <button className="border-b border-blue-500" onClick={() => history.push("/sponsor/hubs/" + hub.id + "/edit")}>編集</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
export default HubsTable;